import { render } from "./_Editar.vue?vue&type=template&id=9b585b68&scoped=true"
import script from "./_Editar.vue?vue&type=script&lang=ts"
export * from "./_Editar.vue?vue&type=script&lang=ts"

import "./_Editar.vue?vue&type=style&index=0&id=9b585b68&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9b585b68"

export default script